import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import App from './App';

import Home from './paginas/home';
import NOTFOUND from './paginas/404';
import Login from './paginas/login';
import reportWebVitals from './reportWebVitals';
import IndicadorDetalhe from './paginas/indicadordetalhe';
import * as serviceWorker from './serviceWorker';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <BrowserRouter>
  <Routes>
    <Route path="/" exact={true} element={<Home />}>
      <Route index element={<Home />} />
    
    </Route>
    <Route path="*" exact={true} element={<NOTFOUND />} />

    <Route  path="/login" element={<Login />} />
    <Route  path="/indicador/:id?"  render={<IndicadorDetalhe />} />

  </Routes>
</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
serviceWorker.register();
